import React from 'react';
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();